import axios from 'axios';
import { getIdToken } from './AuthService';
import settings from '../../settings';

const BASE_URL = 'https://developers.api.tunad.io';


const ACCESS_TOKEN = 'BmSPSq5h8W5eTmbDS6yRda5lv7K0yu7J3mbu10Kc';

export {     
    getClientsCreatedByLoggedInUser, 
    registerNewClient,
    deleteClient
};

function registerNewClient(data) {
  const url = `${BASE_URL}/api/client`;
  return axios.post(url, data,
    { headers: 
        {"x-api-key": `${ACCESS_TOKEN}` }
    });
}

function deleteClient(clientID, userID) {
    const url = `${BASE_URL}/api/client`;
    return axios({ method: "delete", url : url, data : {client_id : clientID, sub: userID} ,  headers:  {"x-api-key": `${ACCESS_TOKEN}` }});
}

function getClientsCreatedByLoggedInUser(userID) {
  const url = `${BASE_URL}/api/clients?sub=${encodeURI(userID)}`;
  console.log('axs eder');
  return axios({ method: 'get', url: url, headers: {"x-api-key" : `${ACCESS_TOKEN}` } })
}


// WEBPACK FOOTER //
// ./src/utils/developercentre-api.js